export default {
  /* This section was auto-generated by bzs-helper ($Properties$) */
  attention: { field: 'attention', fieldType: 'text' },
  createdOn: { field: 'createdOn', fieldType: 'date' },
  customerCode: { field: 'customerCode', fieldType: 'text', label: 'Customer', required: true },
  comments: { field: 'comments', fieldType: 'text' },
  customerComment: { field: 'customerComment' },
  customerId: { field: 'customerID', fieldType: 'numeric', isLookupID: true },
  customerName: { field: 'customerName', fieldType: 'text' },
  customerThirdParty: { field: 'customerThirdParty', fieldType: 'text' },
  defaultFluidCode: { field: 'defaultFluidCode', fieldType: 'text', label: 'Fluid' },
  defaultFluidId: { field: 'defaultFluidID', fieldType: 'numeric', isLookupID: true },
  defaultFluidName: { field: 'defaultFluidName', fieldType: 'text' },
  defaultFluidSearchField: { field: 'defaultFluidSearchField', fieldType: 'text' },
  defaultFluidKeywords: { field: 'defaultFluidKeywords', fieldType: 'text' },
  defaultFluidUnitOfMeasureCode: {
    field: 'defaultFluidUnitOfMeasureCode',
    fieldType: 'text',
    default: 'gal'
  },
  defaultFluidUnitOfMeasureId: {
    field: 'defaultFluidUnitOfMeasureID',
    fieldType: 'numeric',
    label: 'Fluid UoM',
    isLookupID: true,
    default: 2
  },
  defaultFluidUnitOfMeasureName: {
    field: 'defaultFluidUnitOfMeasureName',
    fieldType: 'text',
    default: 'Quarts'
  },
  defaultReadingUnitOfMeasureCode: {
    field: 'defaultReadingUnitOfMeasureCode',
    fieldType: 'text',
    default: 'h'
  },
  defaultReadingUnitOfMeasureId: {
    field: 'defaultReadingUnitOfMeasureID',
    fieldType: 'numeric',
    label: 'Reading UoM',
    isLookupID: true,
    default: 4
  },
  defaultReadingUnitOfMeasureName: {
    field: 'defaultReadingUnitOfMeasureName',
    fieldType: 'text',
    default: 'Miles'
  },
  fluidTypeId: { field: 'fluidTypeID', fieldType: 'numeric', isLookupID: true },
  fluidTypeName: { field: 'fluidTypeName', fieldType: 'text' },
  manufacturerModelCode: {
    field: 'manufacturerModelCode',
    fieldType: 'text',
    label: 'Manufacturer'
  },
  manufacturerModelId: { field: 'manufacturerModelID', fieldType: 'numeric', isLookupID: true },
  manufacturerModelName: { field: 'manufacturerModelName', fieldType: 'text' },
  modifiedOn: { field: 'modifiedOn', fieldType: 'date' },
  suggestedInterval: {
    field: 'suggestedInterval',
    label: 'Custom Interval',
    title: 'Custom Interval',
    fieldType: 'numeric',
    type: 'number',
    disableTabbing: true,
    defaultValue: 120,
    min: 0,
    max: 730
  },
  unitId: { field: 'unitID', fieldType: 'numeric' },
  unitName: {
    field: 'unitName',
    fieldType: 'text',
    label: 'Unit Name',
    required: true,
    isLookupID: true
  },
  unitTypeId: { field: 'unitTypeID', fieldType: 'numeric', isLookupID: true },
  unitTypeName: { field: 'unitTypeName', fieldType: 'text' }
};
